export default (value, field) => {
  return {
    type: 'EVENTS/CHANGE_FIELD',
    payload: {
      value,
      field,
    },
  };
};
